import type { Enums } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getAbsenceCategoryIcon(category: Enums<"absenceCategory">): IconName {
	switch (category) {
		case "vacation":
			return "Palmtree";
		case "sick":
			return "Thermometer";
		case "compensation":
			return "Clock";
		case "leave":
			return "CalendarOff";
	}
}
